import { Outlet } from "react-router-dom"
import { Sidebar } from "@/components/sidebar"
import { TopBar } from "@/components/top-bar"
import { AiSidebar } from "@/components/ai/ai-sidebar"
import { useSidebarStore } from "@/stores/sidebar-store"
import { useAiStore } from "@/stores/ai-store"
import { useNotificationSocket } from "@/hooks/use-notification-socket"
import { useEntityUpdates } from "@/hooks/use-entity-updates"
import { useEffect } from "react"

export function AppLayout() {
  const { isCollapsed, toggle } = useSidebarStore()
  const { isOpen: aiOpen, toggle: toggleAi } = useAiStore()

  // Real-time WebSocket subscriptions
  useNotificationSocket()
  useEntityUpdates()

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && e.key === "\\") {
        e.preventDefault()
        toggle()
      }
      // Cmd+J toggles AI sidebar
      if ((e.metaKey || e.ctrlKey) && e.key === "j") {
        e.preventDefault()
        toggleAi()
      }
    }
    window.addEventListener("keydown", handleKeyDown)
    return () => window.removeEventListener("keydown", handleKeyDown)
  }, [toggle, toggleAi])

  return (
    <div className="flex h-screen overflow-hidden bg-[var(--bg)]">
      <Sidebar />
      <div
        className={`flex flex-1 flex-col overflow-hidden transition-all duration-150 ease-out max-md:ml-0 ${
          isCollapsed ? "md:ml-[60px]" : "md:ml-[260px]"
        }`}
        style={{
          marginRight: aiOpen ? 420 : 0,
        }}
      >
        <TopBar />
        <main className="flex-1 overflow-auto p-5 md:p-6">
          <Outlet />
        </main>
      </div>
      <AiSidebar />
    </div>
  )
}
